import { Box } from "@mui/material";
import SearchOptions from "datalign-module-template/models/search-options";
import SearchResultList from "./search-result-list/SearchResultList";
import SolrService from "services/SolrService";
import Input from "models/input/input";
import { Toaster } from "ui-widgets";
import { useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState, useCallback } from "react";
import { FacetFields } from "models/facet-fields";
import Header from "../header/Header";
import AnalyticsService from "services/AnalyticsService";

const analyticsService = new AnalyticsService();

const { solrService } = new SolrService();

const SearchResultPage = () => {
  const abortRef = useRef<AbortController>();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchOptions, setSearchOptions] = useState<SearchOptions>({
    order_by: {
      column_name: "updated_at",
      order: "desc",
    },
    page_num: 0,
    page_rows: 10,
    search_term: "",
  });
  const [inputs, setInputs] = useState<Input[]>();
  const [count, setCount] = useState<number>(0);
  const [facetFields, setFacetFields] = useState<FacetFields>();

  const HandleFacetChange = useCallback(
    (filterType: string, filterField: string) => {
      const updatedParams = new URLSearchParams(searchParams);
      if (updatedParams.getAll(filterType).includes(filterField)) {
        updatedParams.delete(filterType, filterField);
      } else {
        updatedParams.set(filterType, filterField);
      }
      setSearchParams(updatedParams);
    },
    [searchParams],
  );

  const fetchData = useCallback(async () => {
    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    const signal = controller.signal;
    abortRef.current = controller;
    const newSearchOptions = {
      order_by: {
        column_name: searchParams.get("order_by") ?? "updated_at",
        order: searchParams.get("order_dir") ?? "desc",
      },
      page_num: +(searchParams.get("page") ?? 0),
      page_rows: +(searchParams.get("rows") ?? 10),
      search_term: searchParams.get("search_term") ?? "",
    };
    setSearchOptions(newSearchOptions);
    solrService
      .list<Input>(
        signal,
        newSearchOptions,
        Array.from(searchParams.entries()),
        true,
      )
      .then((res) => {
        setInputs(res.data);
        setCount(res.count);
        setFacetFields(res.facets);
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.error(err);
          Toaster.makeToast(
            err?.message
              ? err.message
              : "An error occurred when searching inputs!",
            "error",
          );
        }
      });
  }, [searchParams]);

  useEffect(() => {
    fetchData();
  }, [fetchData, searchParams]);

  useEffect(() => {
    analyticsService.send();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          mb: 5,
          width: { xl: "80vw", md: "90vw", sm: "95vw" },
        }}
      >
        <Header showBreadcrumb={true} />
        <SearchResultList
          count={count}
          inputs={inputs}
          searchOptions={searchOptions}
          facetFields={facetFields}
          HandleFacetsChange={HandleFacetChange}
        />
      </Box>
    </Box>
  );
};

export default SearchResultPage;
